import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskToPattern',
})
export class MaskToPatternPipe implements PipeTransform {
  transform(mask?: RegExp): Record<string, { pattern: RegExp }> {
    if (!mask) {
      return null;
    }

    return { '0': { pattern: new RegExp(mask) } };
  }
}
